const API = process.env.STORE_NAME ?? "store";
const API_URL = process.env.REACT_APP_API_URL ?? "http://localhost:8080";
export {
  API,
  API_URL
};
